/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { extend } from 'flarum/common/extend';
import { slug } from '../../common';
import app from 'flarum/forum/app';
const t = function () {
  return app.translator.trans(...arguments);
};
const prfx = `${slug}.forum.settings`;
export default () => {
  // NotificationGrid only reaches the forum bundle through the lazily-loaded SettingsPage
  // chunk, so a synchronous import of it resolves to undefined — patch it by path instead.
  extend('flarum/forum/components/NotificationGrid', 'notificationTypes', function (items) {
    // With notifications off the server registers no preference for the type, so a toggle would be accepted and dropped.
    if (!app.forum.attribute(`${slug}.gamification.enabled`) || !app.forum.attribute(`${slug}.enable-notifications`)) {
      return;
    }
    items.add('achievementUnlocked', {
      name: 'achievementUnlocked',
      icon: 'fas fa-bullseye',
      label: t(`${prfx}.notify_achievement_unlocked`)
    });
  });
};